import React, { memo, useEffect, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { SSO_LOGIN_ACCOUNT_TYPE } from 'shared-modules/constants/apiConstant';
import { loginUserRequest, replace, logoutUser } from '../../redux/actions';
import { store } from '../../redux/store';
import { Spin } from '../../components';
import styles from './ssoAuthPage.module.scss';
import { HOME, LOGIN } from '../../constants';

const SSOAuthPage = () => {
  const dispatch = useDispatch();

  const parsedQueryRef = useRef(store.getState().router.location.query);
  const hasStartedSSOLoginRef = useRef(false);

  const successCallback = useCallback(() => {
    // Redirect to root page, AWS authenticatedUser object is already fine now
    dispatch(replace(`/${HOME}`));
  }, [dispatch]);

  const redirectToLogin = useCallback(() => {
    window.location.replace(`/${LOGIN}`);
  }, []);

  // logout & redirect to /login
  const ssoLoginFailureHandler = useCallback(() => {
    dispatch(
      logoutUser({
        successCallback: redirectToLogin,
      }),
    );
  }, [dispatch, redirectToLogin]);

  const processSSOLogin = useCallback(() => {
    const { data, portalId } = parsedQueryRef.current;
    if (!data || !portalId) {
      ssoLoginFailureHandler();
      return;
    }

    dispatch(
      loginUserRequest({
        login: portalId,
        password: data,
        accountType: SSO_LOGIN_ACCOUNT_TYPE,
        successCallback,
        errorCallback: ssoLoginFailureHandler,
      }),
    );
  }, [dispatch, successCallback, ssoLoginFailureHandler]);

  useEffect(() => {
    // one time guard
    if (hasStartedSSOLoginRef.current) {
      return;
    }
    hasStartedSSOLoginRef.current = true;
    processSSOLogin();
  }, [processSSOLogin]);

  return (
    <div className={styles.wrapper}>
      <Spin className={styles.loader} />
    </div>
  );
};

export default memo(SSOAuthPage);
